import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";

import { getDurationLabel } from "../../utils";
import { SLOWEST_ITEMS_CARD_GRID_TEMPLATE } from "./constants";
import styles from "./styles.module.css";
import { SlowestItem } from "./types";

type RunObservabilitySlowestItemsCardRowProps = SlowestItem & {
  widthPercent: number;
};

const RunObservabilitySlowestItemsCardRow = ({
  title,
  subtitle,
  icon,
  seconds,
  widthPercent,
}: RunObservabilitySlowestItemsCardRowProps) => (
  <Box
    grid
    gridTemplate={SLOWEST_ITEMS_CARD_GRID_TEMPLATE}
    gap="large"
    align="center"
    padding="medium 0"
    fullWidth
  >
    <Box direction="column" justify="center" zeroMinWidth className={styles.label}>
      <Box align="center" gap="small" zeroMinWidth>
        {icon && <Icon src={icon} noShrink />}

        <TextEllipsis tooltip={title}>
          {(ellipsisProps) => (
            <Typography {...ellipsisProps} tag="span" variant="p-body3">
              {title}
            </Typography>
          )}
        </TextEllipsis>
      </Box>

      {subtitle && (
        <TextEllipsis tooltip={subtitle}>
          {(ellipsisProps) => (
            <Typography {...ellipsisProps} tag="span" variant="p-body4" color="secondary">
              {subtitle}
            </Typography>
          )}
        </TextEllipsis>
      )}
    </Box>

    <div className={styles.track}>
      <div className={styles.bar} style={{ width: `${widthPercent}%` }} />
    </div>

    <Typography
      tag="span"
      variant="p-body3"
      color="secondary"
      align="right"
      className={styles.duration}
    >
      {getDurationLabel(seconds)}
    </Typography>
  </Box>
);

export default RunObservabilitySlowestItemsCardRow;
